import type { Release } from '../../../types';

const clsr: Release = {
  name: 'clsr',
  short_description: 'Broken Beat, Glitch & Melodic IDM EP',
  description:
    "Clsr is a bold 7-Track collection marked by intricate breakbeats, chopped micro-samples, and deep melodic synth textures. Balancing raw rhythmic complexity with melancholic harmony on cuts like 'cold as an ice', 'have to leave', and 'imperfection', it remains a quintessential milestone in joev's experimental discography.",
  tracklist: [
    {
      trackname: 'cold as an ice',
      duration: '4:52 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/cold-as-an-ice',
      },
    },
    {
      trackname: 'dont mind me',
      duration: '4:27 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/dont-mind-me',
      },
    },
    {
      trackname: 'have to leave',
      duration: '2:59 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/have-to-leave',
      },
    },
    {
      trackname: 'imperfection',
      duration: '3:58 min',
      tracknr: '04',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/imperfection',
      },
    },
    {
      trackname: 'prty song',
      duration: '3:47 min',
      tracknr: '05',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/prty-song',
      },
    },
    {
      trackname: 's|ren (lp version)',
      duration: '3:26 min',
      tracknr: '06',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/s-ren-lp-version',
      },
    },
    {
      trackname: 'trying to (remix)',
      duration: '5:26 min',
      tracknr: '07',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/trying-to-remix',
      },
    },
  ],
  date: '01-2014',
  bgColor: '#959387',
  cover: 'joevnoise_clsr.png',
  detail_link: 'clsr',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/clsr',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise/sets/clsr',
    },
  ],
};

export default clsr;
